










































































































import { Component, Vue } from "vue-property-decorator";
import EventMetrics from "@/views/admin/event_metrics//EventMetrics.vue";
import { checkSelfRole, isSuperAdmin } from "@/common/role_utils";

@Component({
  components: {
    EventMetrics,
  },
})
export default class AdminToolMenu extends Vue {
  isOwner = checkSelfRole("owner");
  isSuperAdmin = isSuperAdmin();

  get activeMenu() {
    if (this.$route.path.includes("department")) return "department";
    else if (this.$route.path.includes("archive_list")) return "archive";
    else if (this.$route.path.includes("tarf-history")) return "tarf";
    else if (this.$route.path.includes("company-budget")) return "budget";
    else if (this.$route.path.includes("room-setup")) return "room";
    else if (this.$route.path.includes("handbook")) return "handbook";
    else if (this.$route.path.includes("favorite_category"))
      return "favorite_category";
    else if (this.$route.path.includes("shift")) return "shift";
    else return "not_select";
  }
  selectToolMenu(toolMenu: string) {
    this.$router.push({ path: `/admin/${toolMenu}` });
  }
}
